module.exports = __webpack_public_path__ + "static/2-a8517f101e02854d7f518c2e763401e5.jpg";